export class ModalConfig<D = any> {
  data: D;
}
